import { isNull, isUndefined } from 'lodash';

const getObjectByNameFromArray = (arr, name) => arr?.find((item) => item?.name === name) || {};

export const generateTableHead = (columns) => [
  { title: 'All', access: true },
  { title: 'ID', access: true, class: 'p-l', ...getObjectByNameFromArray(columns, 'id') },
  { title: 'User', access: true, attrs: { style: { minWidth: '100px' } }, ...getObjectByNameFromArray(columns, 'username') },
  { title: 'Total charge', access: true, ...getObjectByNameFromArray(columns, 'order_id') },
  { title: 'Link', access: true },
  { title: 'Quantity', access: true },
  { title: 'Service', access: true },
  { title: 'Runs', access: true },
  { title: 'Interval', access: true },
  { title: 'Total quantity', access: true },
  { title: 'Date', access: true, attrs: { width: '10%' }, ...getObjectByNameFromArray(columns, 'created') },
  { title: 'Status', access: true },
  { title: '', access: true },
].filter((item) => item.access);

export const generateTableBody = (item, access) => [
  { type: 'checkbox', value: null, access: access.bulk_status || access.bulk_cancel },
  { type: 'id', value: item.id, class: 'p-l', access: true },
  { type: 'user', value: item.user, attrs: { style: { minWidth: '100px' } }, access: true },
  { type: 'charge', value: item.charge, access: true },
  { type: 'link', value: item.link, access: true, class: 'link' },
  { type: 'quantity', value: item.quantity, access: true },
  { type: 'service', value: item.service, access: true, class: 'service' },
  { type: 'runs', value: item.runs, access: true },
  { type: 'interval', value: item.interval, access: true },
  { type: 'total_quantity', value: item.total_quantity, access: true },
  { type: 'date', value: item.created, access: true },
  { type: 'status', value: item.status_name, access: true },
  { type: 'actions', value: null, class: 'td-caret', access: true },
].filter((item) => item.access);

export const itemDropStatuses = (statuses, itemAccess = [], t) => {
  if (itemAccess === false) {
    return [];
  }
  return statuses?.filter((item) => itemAccess.includes(item.id)).map((elem) => ({ id: elem.id, title: t(`ActionsList.${elem.title}`) }));
};

export const getItemActions = (item, access) => [
  {
    title: 'Complete',
    id: 1,
    access: item?.access?.complete && access?.complete,
  },
  {
    title: 'Cancel and refund',
    id: 2,
    access: item?.access?.cancel && access?.cancel,
  },
].filter((item) => item.access);

export const generateMassDrops = (access) => ({
  items: [
    {
      title: 'Complete',
      id: 1,
      access: access.bulk_complete,
    },
    {
      title: 'Cancel and refund',
      id: 2,
      access: access.bulk_cancel,
    },
  ].filter((item) => item.access),
});

export const getSelectedServices = (services, selectedServices) => {
  if (services.length && selectedServices?.length) {
    return services.filter((method) => !!selectedServices.includes(method.id));
  }
  return [];
};

export const getServicesFilterName = (services) => {
  if (isNull(services) || isUndefined(services) || !services.length) {
    return 'Service';
  }
  return `Service (${services.length})`;
};

/**
 * @name prepareConfirmBtnsText
 * @param actionKey {String} - Ключ события
 * @param actionType {Number} - Тип события
 */
export const prepareConfirmBtnsText = (actionKey, title, actionType) => {
  if (actionType === 'single') {
    switch (title) {
    case 'Complete':
      return {
        confirmBtnText: 'Change',
        cancelBtnText: 'Close',
        submitStyle: 'primary',
      };

    case 'Cancel and refund':
      return {
        confirmBtnText: 'Cancel and refund',
        cancelBtnText: 'Close',
      };

    default:
      return {
        confirmBtnText: '',
        cancelBtnText: '',
      };
    }
  }

  if (actionType === 'mass') {
    switch (title) {
    case 'Complete':
      return {
        confirmBtnText: 'Change',
        cancelBtnText: 'Close',
        submitStyle: 'primary',
      };

    case 'Cancel and refund':
      return {
        confirmBtnText: 'Cancel and refund',
        cancelBtnText: 'Close',
      };

    default:
      return {
        confirmBtnText: '',
        cancelBtnText: '',
      };
    }
  }
};
